import * as Backend from '@/core/backend'
import moment from 'moment'
// import { UserDetail } from '@/core/userDetail'

// Columns of the table and columns picker.
// "text" is used for the translation
// "value" is used for the data key of the endpoint data

export const columns = [
  {
    text: 'Facility',
    value: 'Facility',
    width: '50px',
    visible: true
  }, {
    text: 'FacilityDescription',
    value: 'FacilityDescription',
    width: '50px',
    visible: false
  }, {
    text: 'DateFirst',
    value: 'DateFirst',
    width: '110px',
    visible: true
  }, {
    text: 'DateSecond',
    value: 'DateSecond',
    width: '110px',
    visible: true
  }, {
    text: 'DateFirstDate',
    value: 'DateFirstDate',
    width: '110px',
    visible: false
  }, {
    text: 'DateSecondDate',
    value: 'DateSecondDate',
    width: '110px',
    visible: false
  }, {
    text: 'DateFirstTime',
    value: 'DateFirstTime',
    width: '110px',
    visible: false
  }, {
    text: 'DateSecondTime',
    value: 'DateSecondTime',
    width: '110px',
    visible: false
  }, {
    text: 'Reg.No.',
    value: 'No',
    width: '50px',
    visible: true
  }, {
    text: 'ScanXRegNo',
    value: 'ScanXRegNo',
    width: '50px',
    visible: true
  }, {
    text: 'ReferenceNo1',
    value: 'ReferenceNo1',
    width: '50px',
    visible: false
  }, {
    text: 'ReferenceNo2',
    value: 'ReferenceNo2',
    width: '50px',
    visible: false
  }, {
    text: 'AgreementNo',
    value: 'AgreementNo',
    width: '50px',
    visible: true
  }, {
    text: 'AgreementName',
    value: 'AgreementName',
    width: '50px',
    visible: true
  }, {
    text: 'DeliveryNo',
    value: 'DeliveryNo',
    width: '50px',
    visible: true
  }, {
    text: 'DeliveryName',
    value: 'DeliveryName',
    width: '50px',
    visible: true
  }, {
    text: 'CustomerNo',
    value: 'CustomerNo',
    width: '50px',
    visible: true
  }, {
    text: 'CustomerName',
    value: 'CustomerName',
    width: '50px',
    visible: true
  }, {
    text: 'CustomerAddressNo',
    value: 'CustomerAddressNo',
    width: '50px',
    visible: false
  }, {
    text: 'CustomerAddressName',
    value: 'CustomerAddressName',
    width: '50px',
    visible: false
  }, {
    text: 'CustomerAddress',
    value: 'CustomerAddress',
    width: '50px',
    visible: false
  }, {
    text: 'CarrierNo',
    value: 'CarrierNo',
    width: '50px',
    visible: true
  }, {
    text: 'CarrierName',
    value: 'CarrierName',
    width: '50px',
    visible: true
  }, {
    text: 'ArticleNo',
    value: 'ArticleNo',
    width: '50px',
    visible: true
  }, {
    text: 'ArticleName',
    value: 'ArticleName',
    width: '50px',
    visible: true
  }, {
    text: 'EwcCode',
    value: 'DetailEwcCode',
    width: '50px',
    visible: false
  }, {
    text: 'EwcName',
    value: 'DetailEwcName',
    width: '50px',
    visible: false
  }, {
    text: 'ProducerNo',
    value: 'ProducerNo',
    width: '50px',
    visible: true
  }, {
    text: 'ProducerName',
    value: 'ProducerName',
    width: '50px',
    visible: true
  }, {
    text: 'PlantNo',
    value: 'PlantNo',
    width: '50px',
    visible: false
  }, {
    text: 'PlantName',
    value: 'PlantName',
    width: '50px',
    visible: false
  }, {
    text: 'ContainerNo',
    value: 'ContainerNo',
    width: '50px',
    visible: true
  }, {
    text: 'ContainerName',
    value: 'ContainerName',
    width: '50px',
    visible: true
  }, {
    text: 'VehicleNo',
    value: 'VehicleNo',
    width: '50px',
    visible: true
  }, {
    text: 'VehicleName',
    value: 'VehicleName',
    width: '50px',
    visible: true
  }, {
    text: 'VehicleLicensePlateNo',
    value: 'VehicleLicensePlateNo',
    width: '50px',
    visible: true
  }, {
    text: 'RequisitionNo1',
    value: 'RequisitionNo1',
    width: '50px',
    visible: true
  }, {
    text: 'RequisitionNo2',
    value: 'RequisitionNo2',
    width: '50px',
    visible: true
  }, {
    text: 'Comment1',
    value: 'Comment1',
    width: '50px',
    visible: true
  }, {
    text: 'Comment2',
    value: 'Comment2',
    width: '50px',
    visible: true
  }, {
    text: 'Comment3',
    value: 'Comment3',
    width: '50px',
    visible: true
  }, {
    text: 'Comment4',
    value: 'Comment4',
    width: '50px',
    visible: true
  }, {
    text: 'WeightFirst',
    value: 'WeightFirst',
    width: '50px',
    visible: true
  }, {
    text: 'WeightSecond',
    value: 'WeightSecond',
    width: '50px',
    visible: true
  }, {
    text: 'WeightNet',
    value: 'WeightNet',
    width: '50px',
    visible: true,
    sum: true
  },
  {
    text: 'Print',
    value: 'Print',
    width: '50px',
    visible: false
  }
]

export const registrationSimpeColumns = [
  {
    text: 'Facility',
    value: 'Facility',
    width: '50px',
    visible: true
  }, {
    text: 'FacilityDescription',
    value: 'FacilityDescription',
    width: '50px',
    visible: false
  },
  {
    text: 'DateFirst',
    value: 'DateFirst',
    width: '110px',
    visible: true
  }, {
    text: 'DateSecond',
    value: 'DateSecond',
    width: '110px',
    visible: true
  }, {
    text: 'ScanXRegNo',
    value: 'ScanXRegNo',
    width: '50px',
    visible: true
  }, {
    text: 'AgreementName',
    value: 'AgreementName',
    width: '50px',
    visible: true
  }, {
    text: 'DeliveryNo',
    value: 'DeliveryNo',
    width: '50px',
    visible: true
  }, {
    text: 'ContainerName',
    value: 'ContainerName',
    width: '50px',
    visible: true
  }, {
    text: 'ArticleNo',
    value: 'ArticleNo',
    width: '50px',
    visible: true
  }, {
    text: 'ArticleName',
    value: 'ArticleName',
    width: '50px',
    visible: true
  }, {
    text: 'VehicleName',
    value: 'VehicleName',
    width: '50px',
    visible: true
  }, {
    text: 'WeightFirst',
    value: 'WeightFirst',
    width: '50px',
    visible: true
  }, {
    text: 'WeightSecond',
    value: 'WeightSecond',
    width: '50px',
    visible: true
  }, {
    text: 'WeightNet',
    value: 'WeightNet',
    width: '50px',
    visible: true,
    sum: true
  }
]

export async function loadReportData (filter) {
  if (process.env.NODE_ENV === 'development') console.log('--> Loading reports with filter ', filter)
  var input = {
    apiName: 'Reports.LoadReportData',
    inputData: {
      ReportCriteria: {
        Datatype: 'registration',
        Fields: ['Facility', 'Date', 'RegistrationNo', 'AgreementNo', 'AgreementName'],
        Filter: {
          Completed: true,
          ...filter
        },
        Sorting: [
          {
            Field: 'articleNo',
            Direction: 'asc'
          },
          {
            Field: 'registrationNo',
            direction: 'desc'
          }
        ],
        Pagination: {
          Offset: 0,
          Count: 2,
          Last: false
        }
      }
    }
  }
  // Lets add hours, minutes and seconds
  var dateFrom = new Date(input.inputData.ReportCriteria.Filter.DateFrom)
  dateFrom.setHours(0)
  dateFrom.setMinutes(0)
  dateFrom.setSeconds(0)
  var dateTo = new Date(input.inputData.ReportCriteria.Filter.DateTo)
  dateTo.setHours(23)
  dateTo.setMinutes(59)
  dateTo.setSeconds(59)

  // API must always have dates in UTC timezone
  input.inputData.ReportCriteria.Filter.DateFrom = moment.utc(moment(dateFrom).utc()).format()
  input.inputData.ReportCriteria.Filter.DateTo = moment.utc(moment(dateTo).utc()).format()
  const res = await Backend.callApi(input)
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'Reports.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadFacilityData (params) {
  const res = await Backend.callApi({
    apiName: 'Reports.LoadFacilityData',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}
